import { parseCookies, setCookie as nookiesSet } from 'nookies';
import type { CookieKeyType, FixedValueCookieType } from '@/constants/cookie';
import { FIXED_VALUE_COOKIE } from '@/constants/cookie';

export const getCookie = (keyType: CookieKeyType) => {
  const cookies = parseCookies();
  return cookies[keyType];
};

type CookieSerializeOptions = Parameters<typeof nookiesSet>[3];

export const setCookie = (keyType: FixedValueCookieType, options?: CookieSerializeOptions) => {
  const { KEY, VALUE } = FIXED_VALUE_COOKIE[keyType];
  nookiesSet(null, KEY, VALUE, options);
};
